import * as Sentry from '@sentry/angular-ivy';
import { environment } from '@web-frontend/environments';
import Package from '../package.json';

const envsAllowed = ['app'];

const hostname = window.location.hostname;
const isLocal = /^(localhost|172\.16|192\.168)/.test(hostname);
const env = isLocal ? 'local' : hostname.split('.')[0];
const version = Package?.version || 'unknown';

const envIsAllowed = (env: string): boolean => envsAllowed.includes(env);

export function InitSentry(): void {
  try {
    if (envIsAllowed(env)) {
      sentrySetup();
    }
  } catch (error) {
    console.error('Error initializing Sentry', error);
  }

  function sentrySetup() {
    Sentry.init({
      dsn: environment.dsnSentry,
      release: version,
      environment: env,
      integrations: [
        Sentry.httpClientIntegration({
          failedRequestStatusCodes: [409, [500, 599]],
        }),
        Sentry.browserApiErrorsIntegration({
          setTimeout: false,
          setInterval: false,
          requestAnimationFrame: false,
          XMLHttpRequest: true,
          eventTarget: false,
        }),
      ],
      tracesSampleRate: 0,

      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 0,

      sendClientReports: false,

      beforeSend(event) {
        if (event.exception || event.request) {
          const statusCode =
            event.contexts?.response?.status_code ||
            event.extra?.status_code ||
            event.tags?.status_code;

          if (statusCode && typeof statusCode === 'number') {
            if (statusCode >= 500 && statusCode <= 599) {
              event.level = 'fatal';
            }
          }

          if (event.request) {
            event.extra = {
              ...event.extra,
              request_body: event.request.data || event.extra?.request_body,
              request_query_params:
                event.request.query_string || event.extra?.query_params,
              request_method: event.request.method,
              request_url: event.request.url,
              request_headers: event.request.headers,
            };

            event.tags = {
              ...event.tags,
              http_method: event.request.method,
              http_status: statusCode?.toString(),
            };
          }
        }

        event.tags = {
          ...event.tags,
          squad: 'core',
          release: version,
        };
        return event;
      },
    });
  }
}
